// extracted by mini-css-extract-plugin
module.exports = {"sectionName":"ErrorBoundary_sectionName__31Jfs"};